<template>
  <div class="about">
    <Header/>
    <div class="body">
      <div class="sobre">
        <h2 class="msgs"> <font-awesome-icon icon="mobile-alt" class="icon_spot" /> Tecnologias</h2><br>
        <p>O Cursinho Sapiência te ensina a usar a tecnologia e o mundo digital a seu favor!!</p>
        <p>Veja como seu celular pode ser um aliado nos estudos:</p> <br>
        <carousel
          id="tec_carousel"
         :items="1"
         :nav="false"
         :center="true"
         >
         <div class="item">
           <hr><br>
           <div id="localizacao">
             <!-- <div class="img_tec">
               <img src="../assets/img/qr.png" alt="Avatar" style="width:100%;height:100%;">
             </div> -->
             <div class="img_tec">
               <h4 class="p_material" style="text-align:center">KINDLE</h4>
               <p class="txt_tec">O mundo está em suas mãos. Com essa ferramenta você pode acessar qualquer apostila e qualquer livro que você tenha interesse, independente se é matéria nova ou revisão. Chega de carregar peso e não ter praticidade. Bem-vindo a era tecnológica, aluno Sapi.</p>
             </div>
           </div>
        </div>
         <div class="item">
           <hr><br>
           <!--
           <div id="localizacao">
             <div class="img_tec">
               <h4 class="p_material">Realidade Virtual</h4>
               <p class="txt_tec">Para o conteúdo ficar mais próximo de você, usamos também AULAS EM REALIDADE VIRTUAL!! Venha visualizar um tetraedro, uma cena de uma obra literária ou uma célula animal em 3D com nossos óculos de realidade virtual!!</p>
             </div>
             <div class="img_tec">
               <img src="../assets/img/vr.jpg" alt="Avatar" style="width:100%;height:100%;">
             </div>
           </div>
         -->
           <br>
         </div>
         <div class="item">
           <hr><br>
           <div id="localizacao">
             <div class="img_tec" style="justify-content:center;display:flex">
               <img src="../assets/img/app.png" id="cell_img" alt="Avatar" style="border-radius:5%;width:80%;height:80%;">
             </div>
             <div class="img_tec">
               <h4 class="p_material">Aplicativo do Sapiência</h4>
               <p class="txt_tec">No aplicativo Sapiência você tem acesso a todos os materiais extras (listas de exercício, textos e músicas passadas em aula) e ainda aos seus rendimentos do simulado, para acompanhar de perto o seu desenvolvimento e o seu conteúdo. </p>
             </div>
           </div>
        </div>
       </carousel>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import carousel from 'vue-owl-carousel'

export default{
  components:{
    Header,
    Footer,
    carousel
  }
}

</script>

<style>
  @import "../assets/style_padrao.css";
  .img_tec{
    width:40%;
    margin-right: 5%;
  }
  .txt_tec{
    text-align: justify!important;
  }
  @media only screen and (max-width: 600px) {
    .img_tec{
      margin-right: 0%;
      width:100%;
    }
    #cell_img{
      width:50%!important;
    }
  }
</style>
<style scoped>
  @media screen and (min-width: 781px) {
    #tec_carousel >>> .owl-item.cloned{
      display: none !important;
     }
     #tec_carousel >>> .owl-stage{
       transform:none !important;
       transition: none !important;
       width: auto !important;
     }
     #tec_carousel >>> .owl-item{
       width: auto !important;
     }
     #tec_carousel >>> .owl-dot{
       display: none !important;
     }
  }
  </style>
